// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1tfCK","col":"CardReaderDesc_col__3HNku","label":"CardReaderDesc_label__3cyy0"};